import { Table, Row, Col, Form, Modal } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import "../components/button.css";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Pagination from "@mui/material/Pagination";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import Alert from "@mui/material/Alert";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";

export default function PerformersDataChoodeOne({ taskId, refreshData }) {
  registerLocale("pl", pl);
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [task, setTask] = useState([]);
  const [taskPerformers, setTaskPerformers] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [performer, setPerformer] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [text, setText] = useState("Pobieranie danych...");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [choosen, setChoosen] = useState(0);
  const [selectedPerformers, setSelectedPerformers] = useState([]);
  const [showCommunicate, setShowCommunicate] = useState(false);
  const [responseAssignment, setResponseAssignment] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        let response = await apiRequest("users/2", "GET");
        if (choosen > 0) {
          response = response.filter((response) => response.id !== choosen);
        }
        setData(response);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, [userData, choosen]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        const response = await apiRequest("task/" + taskId, "GET");

        setTask(response);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, [userData, taskId]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        const response = await apiRequest("taskperformers/" + taskId, "GET");
        setTaskPerformers(response);
        console.log("teaskperformers: ", response);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!userData) return;
    const fetchData = async () => {
      try {
        const response = await apiRequest(`search/2`, "POST", {
          param: searchValue,
        });
        setData(response);
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error("Błąd wyszukiwania", error);
      }
    };
    fetchData();
  }, [searchMode, userData, searchValue]);

  useEffect(() => {
    if (taskPerformers) {
      setSelectedPerformers((prev) => {
        const mapped = taskPerformers.map((tp) => ({
          id: tp.performerId,
          name: tp.name,
          date: tp.dateassignment ? new Date(tp.dateassignment) : null,
          assigned: true,
        }));
        // unikamy nadpisania poprzednich, łączymy
        return [
          ...prev.filter((p) => !mapped.some((m) => m.id === p.id)),
          ...mapped,
        ];
      });
    }
  }, [taskPerformers]);

  const handleCheckboxChange = (id, fullname) => {
    if (selectedPerformers.find((p) => p.id === id)) {
      setSelectedPerformers(selectedPerformers.filter((p) => p.id !== id));
    } else {
      setSelectedPerformers([
        ...selectedPerformers,
        { id, name: fullname, date: null, assigned: false },
      ]);
    }
  };

  const handleDateChange = (id, newDate) => {
    if (!newDate) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0); // zerujemy czas, żeby porównania były tylko po dacie

    if (newDate < today) {
      //alert("Data musi być późniejsza niż dziś!");
      setApiResponse({
        title: "Nieprawidłowa data",
        severity: "warning",
        info: "Data musi być późniejsza niż dziś!",
      });
      setShowApiResponse(true);
      return;
    } else {
      setShowApiResponse(false);
    }

    const isDuplicate = selectedPerformers.some(
      (p) =>
        p.id !== id &&
        p.date &&
        format(p.date, "yyyy-MM-dd") === format(newDate, "yyyy-MM-dd")
    );

    if (isDuplicate) {
      //alert("Każdy Wykonawca musi mieć inną datę!");
      setApiResponse({
        title: "Nieprawidłowa data",
        severity: "warning",
        info: "Każdy Wykonawca musi mieć inną datę ważności Zlecenia!",
      });
      setShowApiResponse(true);
      return;
    } else {
      setShowApiResponse(false);
    }

    setSelectedPerformers(
      selectedPerformers.map((p) => (p.id === id ? { ...p, date: newDate } : p))
    );
  };

  const handleSave = async (id, date) => {
    const formattedDate = date ? format(date, "yyyy-MM-dd") : null;

    if (!formattedDate || formattedDate === "1970-01-01") {
      setShowCommunicate(true);
      return;
    }
    setShowCommunicate(false);

    try {
      const response = await apiRequest("taskassignment", "POST", {
        taskId,
        performer: id,
        dateassignment: formattedDate,
      });

      if (response?.error_msg === 200) {
        setSelectedPerformers((prev) =>
          prev.map((p) =>
            p.id === id ? { ...p, assigned: true, date: formattedDate } : p
          )
        );
      }
    } catch (error) {
      console.error("Błąd wysyłania do API", error);
    }
  };

  /*
  const handleDelete = (id) => {
    setSelectedPerformers((prev) =>
      prev.map((p) => (p.id === id ? { ...p, assigned: false, date: null } : p))
    );
  };
*/
  const handleDelete = async (id) => {
    try {
      const response = await apiRequest("taskassignmentdelete", "POST", {
        taskId,
        performer: id,
      });
      console.log("hD response: ", response);
      if (response?.error_msg === 200) {
        setSelectedPerformers((prev) =>
          prev.map((p) =>
            p.id === id ? { ...p, assigned: false, date: null } : p
          )
        );
      }
    } catch (error) {
      console.error("Błąd usuwania z API", error);
    }
  };
  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const direction = sortConfig.direction === "asc" ? 1 : -1;
    return a[sortConfig.key] < b[sortConfig.key]
      ? -1 * direction
      : a[sortConfig.key] > b[sortConfig.key]
      ? 1 * direction
      : 0;
  });

  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChangePage = (event, page) => setCurrentPage(page);

  const requestSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setSearchMode(e.target.value.length > 0);
  };

  const handleClose = () => setShow(false);

  const handleShow = () => {
    //if (selectedIds.length > 0) setShow(true);
    const closest = getClosestPerformer();
    if (closest) {
      setPerformer(closest.name);
      setSelectedId(closest.id);
      setShow(true);
    }
  };

  const handleConfirm = async () => {
    setShow(false);
    //console.log("selected: ", selectedId);
    try {
      const response = await apiRequest("taskuser", "POST", {
        taskId: taskId,
        performer: selectedId,
      });
      console.log("response taskuser:", response);
      if (response.error_msg === 200) {
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Zlecenie przekazane do wykonawcy.",
        });
        setShowApiResponse(true);
        refreshData();
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  const getClosestPerformer = () => {
    if (selectedPerformers.length === 0) return null;

    // filtrujemy tylko z datą
    const withDates = selectedPerformers.filter((p) => p.date);
    if (withDates.length === 0) return null;

    // sortujemy rosnąco po dacie i bierzemy pierwszego
    return withDates.reduce((prev, curr) =>
      prev.date < curr.date ? prev : curr
    );
  };

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {/* MODAL */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Czy na pewno chcesz przydzielić zlecenie ID: [{taskId}] <br />
          Wykonawcy: <b>{performer}?</b>
          <br />
          Na wskazany przy Wykonawcy email zostanie wysłany mail z
          powiadomieniem.
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col>
              <Button variant="outlined" onClick={handleClose}>
                Anuluj
              </Button>
            </Col>
            <Col>
              <Button variant="contained" onClick={handleConfirm}>
                Potwierdź
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>

      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={4} sm={3}>
            <TextField
              label="Wyszukaj Wykonawcę"
              variant="outlined"
              onChange={handleSearch}
              fullWidth
            />
          </Col>
          <Col xs={4} sm={6}>
            <Pagination
              count={Math.ceil(data.length / itemsPerPage)}
              page={currentPage}
              onChange={handleChangePage}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Col>
        </Row>
        <hr />
        {userData && task[0] && (
          <>
            <Row>
              <Col>
                <Alert
                  icon={<CircleNotificationsIcon fontSize="inherit" />}
                  severity="info"
                >
                  Należy wybrać Wykonawców i przydzielić terminy, w których
                  Zlecenie może nie zostać podjęte. Każdy termin powinien zostać
                  zapisany. Następnie należy wybrać przycisk „PRZYDZIEL
                  ZADANIE”. Pojawi się komunikat o Wykonawcy, do którego w
                  pierwszej kolejności trafi Zlecenie. Należy pamiętać, aby daty
                  były różne i nie wcześniejsze od bieżącej. W przypadku
                  niepodjęcia Zlecenie po upływie wskazanej daty Zlecenie
                  zostanie przypisane kolejnemu Wykonawcy, a w przypadku braku
                  Wykonawcy zostanie zawrócone do poziomu Rejestracji.
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                Wybierz wykonawcę zlecenia ID: <b>[{taskId}]</b>
              </Col>

              <Col>
                Temat: <b>{task[0].topic}</b>
              </Col>

              <Col>
                Zleceniodawca: <b>{task[0].reporter}</b>
              </Col>
            </Row>
          </>
        )}
        <hr />
        {showCommunicate && <p className="p1">Brak wybranej daty</p>}
        <Row>
          <Col>
            {selectedPerformers.map((p) => (
              <div
                key={p.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <span className="p1" style={{ minWidth: "150px" }}>
                  {p.name}
                </span>

                {!p.assigned ? (
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={pl}
                  >
                    <DatePicker
                      label="Data ważności"
                      value={p.date}
                      onChange={(newValue) => handleDateChange(p.id, newValue)}
                      slotProps={{
                        textField: {
                          size: "small",
                          style: { minWidth: "160px" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                ) : (
                  // tutaj formatujesz datę
                  <span>
                    {p.date ? format(p.date, "yyyy-MM-dd") : "Brak daty"}
                  </span>
                )}

                {!p.assigned ? (
                  <Button onClick={() => handleSave(p.id, p.date)}>
                    Zapisz
                    <AddIcon />
                  </Button>
                ) : (
                  <Button onClick={() => handleDelete(p.id)}>
                    Skasuj
                    <ClearIcon />
                  </Button>
                )}
              </div>
            ))}
          </Col>

          {selectedPerformers.length > 0 && (
            <Col>
              <Button variant="outlined" onClick={handleShow}>
                Przydziel zlecenie
              </Button>
            </Col>
          )}
        </Row>

        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th className="td-centered">#</th>
                <th className="td-centered" onClick={() => requestSort("id")}>
                  ID
                </th>
                <th onClick={() => requestSort("fullName")}>Wykonawca</th>
                <th onClick={() => requestSort("permbuild")}>Upr. budowlane</th>
                <th onClick={() => requestSort("cnt2")}>Lb. zleceń br.</th>
                <th onClick={() => requestSort("expertise")}>Rzeczoznawstwo</th>
              </tr>
            </thead>
            {data.length > 0 && userData.userId ? (
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="td-centered">
                      <Form.Check
                        type="checkbox"
                        checked={selectedPerformers.some(
                          (p) => p.id === item.id
                        )}
                        onChange={() =>
                          handleCheckboxChange(item.id, item.fullName)
                        }
                      />
                    </td>
                    <td className="td-centered">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td>{item.fullName}</td>
                    <td className="td-centered">{item.permbuild}</td>
                    <td className="td-centered">{item.cnt2}</td>
                    <td className="td-centered">{item.expertise}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    <h6>{text}</h6>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </ThemeProvider>
    </div>
  );
}
